import 'react-day-picker/lib/style.css'
import React, { useState } from 'react'
import { Box, Link, Typography } from '@material-ui/core'
import { format } from 'date-fns'
import { makeStyles } from '@material-ui/core/styles'
import { themeConWeb } from '../../util/modernThemeConweb'
import { parseDateFromCompactFormat, formatAsMonthDayOrWeekday } from '../../util/dateUtils'
import DatePickerPopup from '../common/DatePickerPopup'

const useStyles = makeStyles(() => ({
  title: {
    fontWeight: 800,
    fontSize: `${themeConWeb.fontSizes.basePlus1}`,
    lineHeight: '24px',
  },
  date: { fontSize: `${themeConWeb.fontSizes.base}` },
  editButton: {
    fontSize: `${themeConWeb.fontSizes.baseMinus1}`,
    fontWeight: 800,
    cursor: 'pointer',
    color: `${themeConWeb.color.two}`,
    '&:hover': {
      textDecoration: `underline ${themeConWeb.color.twoTint}`,
    },
  },
}))

const DatePickerWidget = ({ selectedDate, selectDateStart, locationId }) => {
  const classes = useStyles()
  const [isPickerOpen, setIsPickerOpen] = useState(false)
  const parsedSelectedDate = parseDateFromCompactFormat(selectedDate)
  const [displayedMonth, setDisplayedMonth] = useState(
    new Date(parsedSelectedDate.getFullYear(), parsedSelectedDate.getMonth()),
  )

  const handleMonthChange = newMonth => {
    setDisplayedMonth(newMonth)
  }

  const handleDayClick = (day, { disabled }) => {
    if (disabled) {
      return
    }
    setIsPickerOpen(false)
    return selectDateStart(format(day, 'YYYYMMDD'), locationId)
  }

  const togglePicker = () => {
    setIsPickerOpen(!isPickerOpen)
  }

  return (
    <Box style={{ position: 'relative' }}>
      <Box display="flex" flexDirection="column" alignItems="start">
        <Typography className={classes.title}>Delivery Date </Typography>
        <Typography className={classes.date}>{formatAsMonthDayOrWeekday(selectedDate)}</Typography>
        <Typography className={classes.editButton}>
          <Link onClick={togglePicker}>Edit</Link>
        </Typography>
      </Box>
      {isPickerOpen && (
        <DatePickerPopup
          setIsPickerOpen={setIsPickerOpen}
          handleDayClick={handleDayClick}
          selectedDate={selectedDate}
          displayedMonth={displayedMonth}
          handleMonthChange={handleMonthChange}
        />
      )}
    </Box>
  )
}

export default DatePickerWidget
